import React from 'react'
import { CommentInfo, CommentItem } from './Style'

export default function Comment() {
    return (
        <CommentItem>
            <img src={"/images/person_transparent.png"} />
            <CommentInfo>
                <div>
                    <div>
                        <span>Name</span>
                        <span>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                            <i className="fas fa-star"></i>
                        </span>
                    </div>
                    <span>2à dec 2021</span>
                </div>
                <p>
                    The course you delivered me has surpassed all my expectations.
                    It is one of the best, all-purpose items ever crafted.
                    I love everything about my purchase. Reliable,
                    secure, quirky, easy to clean in and out.
                </p>
            </CommentInfo>
        </CommentItem>
    )
}
